import {
  getFirstRequisition,
  HashIcon,
  Mtds,
  SampleDetailsSection,
  SampleProgress,
  useGetSampleByIdQuery,
  useGetTaskByIdQuery
} from 'prove-common'
import { Link } from 'react-router'
import { PROVETA_URL } from '../../constants'

type MapViewSampleSidebarProps = {
  sampleId: string
}

export function MapViewSampleSidebar({ sampleId }: MapViewSampleSidebarProps) {
  const { data: sample } = useGetSampleByIdQuery(sampleId)
  const { data: task, isLoading: isLoadingTask } = useGetTaskByIdQuery(
    sample?.taskId
  )

  return (
    !!sample && (
      <Mtds.Card
        as={Mtds.Grid}
        className='h-full'
        data-align-content='start'
        data-gap='10'
      >
        <Mtds.Flex data-align='center' data-justify='space-between'>
          <Mtds.Heading data-size='lg'>
            <Mtds.Flex data-align='center' data-gap='1'>
              <HashIcon />
              {sampleId}
            </Mtds.Flex>
          </Mtds.Heading>
          <Mtds.Button as={Link} to={`/samples/${sampleId}`} data-arrow>
            Gå til prøve
          </Mtds.Button>
        </Mtds.Flex>
        <SampleProgress sample={sample} />
        <SampleDetailsSection
          isLoadingTask={isLoadingTask}
          requisition={getFirstRequisition(sample)}
          sample={sample}
          task={task}
          taskLinkTo={`${PROVETA_URL}/tasks/${task?.id}`}
          isProveta={false}
        />
      </Mtds.Card>
    )
  )
}
